// Visibilità condizionale
export function shouldShowQuestion(question, responses) {
  if (!question.condition) return true;
  const { field, value } = question.condition;
  return responses[field] === value;
}

export function getVisibleQuestions(questions, responses) {
  return questions.filter((q) => shouldShowQuestion(q, responses));
}

// Calcolo score completezza (solo domande required visibili)
export function calculateCompletionScore(config, responses, mode) {
  const steps = config[mode] || config.full;
  if (!steps) return 0;
  let totalRequired = 0;
  let answeredRequired = 0;
  steps.forEach((step) => {
    step.questions.forEach((q) => {
      if (!shouldShowQuestion(q, responses)) return;
      if (q.required) {
        totalRequired++;
        if (
          responses[q.id] !== undefined &&
          responses[q.id] !== null &&
          responses[q.id] !== ""
        ) {
          answeredRequired++;
        }
      }
    });
  });
  if (totalRequired === 0) return 100;
  return Math.round((answeredRequired / totalRequired) * 100);
}

// Soglie qualità
export function getQualityRating(score) {
  if (score >= 95) return "underwriting_ready";
  if (score >= 75) return "completo";
  if (score >= 40) return "buono";
  return "incompleto";
}

// Alert assuntivi automatici
export function generateAlerts(config, responses, mode, clientData) {
  const alerts = [];
  if (responses.rct_materiali_pericolosi === true)
    alerts.push({ type: "warning", message: "Utilizzo materiali pericolosi dichiarato - approfondire", field_id: "rct_materiali_pericolosi" });
  if (responses.rct_sinistri_ultimo_triennio === true && responses.rct_num_sinistri > 3)
    alerts.push({ type: "critical", message: "Sinistralità elevata: più di 3 sinistri nel triennio", field_id: "rct_num_sinistri" });
  if (responses.rct_lavoro_altezza === true && responses.rct_altezza_max === "> 20m")
    alerts.push({ type: "warning", message: "Lavori in quota superiore a 20m - rischio elevato", field_id: "rct_altezza_max" });
  if (responses.rct_uso_subappalto === true && responses.rct_qualifica_subappaltatori === "No")
    alerts.push({ type: "critical", message: "Subappaltatori non qualificati/assicurati", field_id: "rct_qualifica_subappaltatori" });
  if (responses.cy_incidenti_precedenti === true)
    alerts.push({ type: "warning", message: "Incidenti informatici precedenti dichiarati", field_id: "cy_incidenti_precedenti" });
  if (responses.cy_mfa === false)
    alerts.push({ type: "warning", message: "MFA non attiva - rischio cyber elevato", field_id: "cy_mfa" });
  if (responses.cy_backup === false)
    alerts.push({ type: "critical", message: "Backup non regolari - rischio critico", field_id: "cy_backup" });
  if (responses.deo_contenziosi === true)
    alerts.push({ type: "critical", message: "Contenziosi in corso contro organi sociali", field_id: "deo_contenziosi" });
  if (responses.rcp_sinistri === true)
    alerts.push({ type: "warning", message: "Sinistri/reclami professionali dichiarati", field_id: "rcp_sinistri" });
  if (clientData?.fatturato > 10000000)
    alerts.push({ type: "info", message: "Fatturato elevato: verificare adeguatezza massimali" });
  if (clientData?.numero_dipendenti > 100)
    alerts.push({ type: "info", message: "Organico numeroso: valutare copertura RCO adeguata" });
  return alerts;
}

// Documenti mancanti
export function getMissingDocuments(branchCode, responses) {
  const docs = [];
  if (branchCode === "rct_rco") {
    if (!responses.rct_certificazioni || responses.rct_certificazioni.length === 0)
      docs.push("Certificazioni qualità (se disponibili)");
    if (responses.rct_sinistri_ultimo_triennio === true)
      docs.push("Dettaglio sinistri ultimo triennio");
    if (responses.rct_polizza_precedente === true)
      docs.push("Copia polizza in scadenza");
  }
  if (branchCode === "cyber_risk") {
    docs.push("Report sicurezza IT (se disponibile)");
    if (responses.cy_incidenti_precedenti === true)
      docs.push("Report incidenti informatici");
  }
  if (branchCode === "car_postuma") {
    docs.push("Computo metrico estimativo");
    docs.push("Cronoprogramma lavori");
  }
  return docs;
}
